const BASE_URL = process.env.REACT_APP_API_URL;

function getToken() {
    return localStorage.getItem("d_c_c_t");
}


export async function getControls() {
 
    try {
      const response = await fetch(`${BASE_URL}/controls/getAll`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
         'Authorization': `Bearer ${getToken()}`,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to get controls');
      }

      const result = await response.json();
      console.log('Controls fetched successfully:', result);
      // Optionally, navigate to another page or show a success message
    } catch (error) {
        console.error('Error fetching controls:', error);
      // Optionally, show an error message to the user
    }
};

export async function getControl(id:any){
  try{
    const response = await fetch(`${BASE_URL}/controls/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getToken()}`,
        },
      });

     

      if (!response.ok) {
        throw new Error('Failed to get control');
      }


      const result = await response.json();
      return result;
  }
  catch(error:any){
    console.error('Error fetching controls:', error);
    throw new Error(error);
  }
}